import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthService } from './auth.service';

const DEACTIVATED_MESSAGE = 'This account has been deactivated';
const NO_PERMISSION_MESSAGE = 'Insufficient permissions';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  const snackBar = inject(MatSnackBar);
  const token = authService.getToken();
  const isLoginRequest = req.url.includes('/auth/login');

  // Clone the request and add authorization header if token exists
  if (token) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  return next(req).pipe(
    catchError((error) => {
      // Handle 401 Unauthorized errors (expired/invalid token)
      if (error.status === 401) {
        authService.logout();
      } else if (!isLoginRequest && error.status === 403 && error.error?.error === DEACTIVATED_MESSAGE) {
        // Account was blocked after the token was issued — every subsequent
        // authenticated request (any endpoint, not just login) gets this 403.
        authService.logout();
        snackBar.open('Your account has been deactivated. Contact an administrator.', 'Close', {
          duration: 8000
        });
      } else if (error.status === 403 && error.error?.error === NO_PERMISSION_MESSAGE) {
        snackBar.open("You don't have permission to do that.", 'Close', { duration: 5000 });
      }
      return throwError(() => error);
    })
  );
};
